<template>
  <div>
  <b-navbar toggleable="lg" type="dark" variant="primary" class="fixed-top">
    <b-navbar-brand href="#">{{$t('logoName')}}</b-navbar-brand>
    <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
    <b-collapse id="nav-collapse" is-nav>
      <b-navbar-nav class="text-uppercase">
        <b-nav-item  href="javascript:void(0)" @click="changeRoute(1)">
          <span class="text-warning">{{$t('mainMenu.projects').toLowerCase()}}</span>
        </b-nav-item>
        <b-nav-item   href="javascript:void(0)" @click="changeRoute(2)">
          <span class="text-light">{{$t("mainMenu.settings").toLowerCase()}}</span>
        </b-nav-item>
        <!-- <b-nav-item  href="/#/oyucat">
          <span class="text-light">{{$t("mainMenu.graphs")}}</span>
        </b-nav-item>  -->
      </b-navbar-nav>
      <b-navbar-nav class="ml-auto">
        <b-nav-item-dropdown right :text="$t('mainMenu.currentLang')">
          <b-dropdown-item href="javascript:void(0)"  v-for="locale in $i18n.locales()" :key="'i81n-' + locale"
			      @click="$i18n.set(locale)" v-if="$i18n.locale() !== locale">{{locale}}
          </b-dropdown-item>
        </b-nav-item-dropdown>
        <b-nav-item-dropdown right>
          
          <b-dropdown-item href="javascript:void(0)">
            {{$t('mainMenu.password')}}
          </b-dropdown-item>
          <b-dropdown-item href="javascript:void(0)" @click="logOut">
            {{$t('logOut')}}
          </b-dropdown-item>
        </b-nav-item-dropdown>
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
  
  <div class="mt-5">
    <b-card-header header-tag="nav" >
      <b-nav class="pl-5" v-if="mainMenu==1">
        <b-nav-item href="/#/addproject" class="ml-5 pl-4">{{$t("mainMenu.project.add")}}</b-nav-item>
        <b-nav-item href="/#/projectlist">{{$t("mainMenu.project.list")}}</b-nav-item>
        <b-nav-item href="/#/dpadlist1">{{$t("mainMenu.project.dpad1")}}</b-nav-item>
        <b-nav-item href="/#/dpadlist2">{{$t("mainMenu.project.dpad2")}}</b-nav-item>
      </b-nav>
      <b-nav class="pl-5" v-if="mainMenu==2">
        <b-nav-item class="ml-5 pl-4">{{$t("mainMenu.setting.companies")}}</b-nav-item>
        <b-nav-item href="/#/users">{{$t("mainMenu.setting.users")}}</b-nav-item>
        <b-nav-item>{{$t("mainMenu.setting.cats")}}</b-nav-item>
        <b-nav-item>{{$t("mainMenu.setting.departments")}}</b-nav-item>
        <b-nav-item>{{$t("mainMenu.setting.level")}}</b-nav-item>
        <b-nav-item>{{$t("mainMenu.setting.budgets")}}</b-nav-item>
        <b-nav-item>{{$t("mainMenu.setting.status")}}</b-nav-item>
        <b-nav-item>{{$t("mainMenu.setting.types")}}</b-nav-item>
        <b-nav-item>{{$t("mainMenu.setting.roles")}}</b-nav-item>
      </b-nav>
    </b-card-header>

  </div>
</div>  
</template>

<script>
import {mapActions,mapState} from 'vuex';
import axios from 'axios';
import {apiDomain,getHeader} from "../config/config";

export default {
  name: 'AppHeader',
  data(){
    return {
      mainMenu:1,
      statisticData:null,
      showOrderLoanModal : false,
      salaryInfo:[],
      
    }
  },
  
  methods:{
    changeRoute(p){
      this.mainMenu = p;
    },
    showLoanModal(){
      this.showOrderLoanModal=true;
      this.$bvModal.show("orderLoanModal");
    },
    
    
    logOut : function(){
      //alert("Server taliin token arilgahaa martavaa Bek chuhal shvv!!! ");
        window.localStorage.removeItem("authUser");
        window.localStorage.clear();
        this.logoutSystem()
        this.$router.push({name:'Login'});
        
        // axios.get(apiDomain+'/admin/logout',{headers:getHeader()})
        // .then(()=>{
        //     window.localStorage.removeItem("authUser");
        //     window.localStorage.clear();
        //     this.$router.push({name:'Login'});
        // })
        // .catch(error => {
        //     alert(error.message);    
        // })
       
    },
    ...mapActions([
        'logoutSystem',
    ]),
   
   
    hasRole(roleName){
      if(this.loginedUser && this.loginedUser.userRoles){
        let roleNames = this.loginedUser.userRoles;
        if(roleNames.length>0){
          //alert(JSON.stringify(roleNames));
          for(let r=0;r<roleNames.length;r++){
            
            if(roleNames[r].name===roleName){
              return true;
            }
          }
        }
        else{
          return false;
        }
      }
      return false;
      
      
    }
  },
  created(){
    // this.setDeliveryRefs(1);
    // this.setDeliveryRefs(2);
    // this.setDeliveryRefs(9);
    // this.setDeliveryRefs(10);
    if(!this.hasRole("ADMIN")){
      window.location.href = "/#/login";
    }
  },
  computed:{
    ...mapState([
        'loginedUser'
    ]),
  }
}
</script>
<style scoped>
 

@-webkit-keyframes pulse {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(204,169,44, 0.4);
  }
  70% {
      -webkit-box-shadow: 0 0 0 10px rgba(204,169,44, 0);
  }
  100% {
      -webkit-box-shadow: 0 0 0 0 rgba(204,169,44, 0);
  }
}
@keyframes pulse {
  0% {
    -moz-box-shadow: 0 0 0 0 rgba(204,169,44, 0.4);
    box-shadow: 0 0 0 0 rgba(204,169,44, 0.4);
  }
  70% {
      -moz-box-shadow: 0 0 0 10px rgba(204,169,44, 0);
      box-shadow: 0 0 0 10px rgba(204,169,44, 0);
  }
  100% {
      -moz-box-shadow: 0 0 0 0 rgba(204,169,44, 0);
      box-shadow: 0 0 0 0 rgba(204,169,44, 0);
  }
}
</style>
